import PropTypes from 'prop-types';
import styles from './Page.module.scss';

const Page = ({ name, children, height, background }) => {
  const style = {
    ...(height && { height: `${height}vh` }),
    ...(background && { backgroundColor: background })
  };
  
  return (
    <div className={styles.page} data-page={name} id={name} style={style}>
      <div className={styles.page__content}>
        {children}
      </div>
    </div>
  );
};

Page.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  height: PropTypes.number,
  background: PropTypes.string
};

export default Page; 